import { STORAGE_KEY } from "../constants.js";
import { monacoStore } from "./monaco.js";
const createThemeSlice = ({
  editorTheme
}) => (set, get) => ({
  theme: null,
  actions: {
    setTheme(theme) {
      const {
        storage
      } = get();
      storage.set(STORAGE_KEY.theme, theme ?? "");
      document.body.classList.remove("graphiql-light", "graphiql-dark");
      if (theme) {
        document.body.classList.add(`graphiql-${theme}`);
        document.documentElement.setAttribute("data-theme", theme);
      } else {
        document.documentElement.removeAttribute("data-theme");
      }
      const {
        monaco
      } = monacoStore.getState();
      const resolvedTheme = theme ?? getSystemTheme();
      const monacoTheme = editorTheme[resolvedTheme];
      monaco == null ? void 0 : monaco.editor.setTheme(monacoTheme);
      set({
        theme,
        monacoTheme
      });
    }
  }
});
function getSystemTheme() {
  const mediaQueryList = window.matchMedia("(prefers-color-scheme: dark)");
  const isDark = mediaQueryList.matches;
  const systemTheme = isDark ? "dark" : "light";
  return systemTheme;
}
export {
  createThemeSlice
};
//# sourceMappingURL=theme.js.map
